<script setup lang="ts">
import type { ProductSetWithImage } from '~/types/api'

const props = defineProps<{
  lineTitle?: string
  sets: ProductSetWithImage[]
}>()

const gridSets = computed(() => {
  return transformSets(props.sets)
})
</script>

<template>
  <UiSection id="products" gray :title="$t('productline.productsGrid.title')">
    <ProductsGrid :sets="gridSets" subtitle-as-title />
  </UiSection>
</template>
